import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Cookies from "js-cookie";

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (!process.env.REACT_APP_GA_MEASUREMENT_ID) {
            return;
        }

        const consent = Cookies.get("user_cookie_consent");

        if (consent === "true") {
            if (!(window as any)._gaInitialized) {
                return;
            }

            ReactGA.send({ hitType: "pageview", page: location.pathname });
            console.log("Page tracked:", location.pathname);
        }
    }, [location]);
}
